import { Component, inject } from '@angular/core';
import { LP_UI_CONFIG } from '../../core/tokens';
import { TabMenuComponent } from '../tab-menu/tab-menu';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss'],
  imports: [TabMenuComponent],
})
export class FooterComponent {
  public cfg = inject(LP_UI_CONFIG);
}
